import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import {
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
  Tabs,
  Tab,
} from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation";
import services from "../../API/services";
import { useDispatch, useSelector } from "react-redux";
import { getRroomPropertyAction } from "../../store/slices/propertySlice";
import Moment from "react-moment";
import ImageUploadBox from "../../components/imageUploadBox";
import { Link } from "react-router-dom";
import { Controller } from "react-hook-form";
import { arrayColumn, isJsonString } from "../../utils/utils";
import { baseImgUrl, baseUrl } from "../../API/client/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import Step3 from "./Step3";
import { useMemo } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import {
  TRAVELLER_CHOICE_TEXT,
  propertyPolicy,
} from "../../constant/constants";
import Services from "../../API/services";
import VerifiedInput from "./VerifiedInput";

const PROPERTY_STATUS = {
  ACTIVE: 3,
  INACTIVE: 4,
  APPROVED: 1,
  REJECTED: 2,
  PENDING: 0,
  ALL: -1,
  PENDINGSTATE: 10,
  HOURLY: 8,
  PREPAID: 9
};

const Property = () => {
  const dispatch = useDispatch();

  const tableRef = useRef(null);

  const { userDetail } = useSelector(authenticationSeletor);

  const { AlertIcon } = Imagesdata || {};
  const [show, setShow] = useState(false);
  const [propertyList, setPropertyList] = useState([]);
  const [imageData1, setImageData1] = useState([]);
  const [imageData2, setImageData2] = useState([]);
  const [imageData3, setImageData3] = useState([]);
  const [imageData4, setImageData4] = useState([]);
  const [imageData5, setImageData5] = useState([]);
  const [imageData6, setImageData6] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [selectedAminites, setselectedAminites] = useState([]);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [imageSet1, setImageSet1] = useState([]);
  const [imageSet2, setImageSet2] = useState([]);
  const [imageSet3, setImageSet3] = useState([]);
  const [imageSet4, setImageSet4] = useState([]);
  const [imageSet5, setImageSet5] = useState([]);
  const [imageSet6, setImageSet6] = useState([]);
  const [localityData, setLocalityData] = useState([]);

  const [zones, setZones] = useState([])
  const [states, setStates] = useState([])
  const [hubs, setHubs] = useState([])
  const [cities, setCities] = useState([])

  const [policyText, setPolicyText] = useState([]);

  const [Couple, setCouple] = useState(false);
  const [Local, setLocal] = useState(false);
  const [Partial, setPartial] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [step, setStep] = useState(1);
  const [editDropDown, setEditDropDown] = useState(-1);
  const [topValueForEditList, setTopValueForEditList] = useState(0);
  const [activeTab, setActiveTab] = useState(PROPERTY_STATUS.PENDING);
  const [showData, setShowData] = useState([]);
  const [travellerData, setTravellerData] = useState([]);
  const [profileImg, setProfileImg] = useState(0);
  const [activeImageState, setActiveImageState] = useState(false);
  const [selectedZoneId, setSelectedZoneId] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm({ ...validation, mode: "onSubmit" });

  const getPropertyData = async () => {
    try {
      const res = await services.property.getRroomsPropertyService();
      if (res.status === 200) {
        setPropertyList(res?.data?.data);
      }
    } catch (error) { }
  };

  const getPropertyCategory = async () => {
    try {
      const res = await services.property.getPropertyCategoryService();
      if (res.status === 200) {
        setCategoryData(res?.data?.data);
      }
    } catch (error) { }
  };

  const getAmenities = async () => {
    try {
      const res = await services.property.getAmenitiesService();
      if (res.status === 200) {
        setAmenitiesData(res?.data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getPropertyData();
    getPropertyCategory();
    getAmenities();
  }, []);

  const resetImages = () => {
    setImageSet1([]);
    setImageSet2([]);
    setImageSet3([]);
    setImageSet4([]);
    setImageSet5([]);
    setImageSet6([]);
    setImageData1([]);
    setImageData2([]);
    setImageData3([]);
    setImageData4([]);
    setImageData5([]);
    setImageData6([]);
  };

  const onHide = () => {
    setShow(false);
    reset();
    resetImages();
    setEditMode(false);
    setselectedAminites([]);
    setPartial(false);
    setCouple(false);
    setLocal(false);
    setTravellerData([]);
    setActiveImageState(false);
    setProfileImg(null);
    setPolicyText([]);
  };

  const onSubmit = async () => {
    const {
      adharNumber,
      amenities,
      bookingPolicy,
      city,
      email,
      firmType,
      firstName,
      lastName,
      latitude,
      longitude,
      panNumber,
      phoneNumber,
      postalCode,
      propertyAddress,
      propertyDescription,
      propertyEmail,
      propertyLandmark,
      propertyName,
      propertyPhone,
      state,
      noOfRooms,
      Locality,
      place_id,
      onboardedRooms,
      roomsCommission,
      // roomSize,
      hub,
      zone,
      haveBanquateLawan,
      havelawn,
      haveRestaurent,
      haveBar,
      haveRoofTop,
      haveConferenceRoom,
      allowHourly,
      payAtHotel
    } = getValues();
    policyText.push(bookingPolicy);
    const policy = JSON.stringify(policyText);
    if (step === 1) {
      let bodyFormData1 = new FormData();
      bodyFormData1.append("name", propertyName);
      bodyFormData1.append("address", propertyAddress);
      bodyFormData1.append("propertyCategoryId", firmType);
      bodyFormData1.append("latitude", latitude);
      bodyFormData1.append("longitude", longitude);
      bodyFormData1.append("ownerFirstName", firstName);
      bodyFormData1.append("ownerLastName", lastName);
      bodyFormData1.append("ownerMobile", phoneNumber);
      bodyFormData1.append("ownerEmail", email);
      bodyFormData1.append("ownerPan", panNumber);
      bodyFormData1.append("ownerAdhar", adharNumber);
      bodyFormData1.append("pincode", postalCode);
      bodyFormData1.append("countryId", "IN");
      bodyFormData1.append("city", city);
      bodyFormData1.append("noOfRooms", noOfRooms);
      bodyFormData1.append("stateId", state);
      bodyFormData1.append("propertyDescription", propertyDescription);
      bodyFormData1.append("propertyMobileNumber", propertyPhone);
      bodyFormData1.append("propertyEmailId", propertyEmail);
      bodyFormData1.append("landmark", propertyLandmark);
      bodyFormData1.append("bookingPolicy", policy);
      // bodyFormData1.append("status", 0);
      bodyFormData1.append("locaidAccept", Local ? 1 : 0);
      bodyFormData1.append("coupleFriendly", Couple ? 1 : 0);
      bodyFormData1.append("partialPayment", Partial ? 1 : 0);
      bodyFormData1.append("status", 0);
      bodyFormData1.append("locality", Locality);
      bodyFormData1.append("travellerChoice", travellerData?.toString());
      bodyFormData1.append(editMode ? "updatedBy" : "createdBy", userDetail?.id);
      bodyFormData1.append("onboardedRooms", onboardedRooms);
      bodyFormData1.append("roomsCommission", roomsCommission);
      // bodyFormData1.append("roomSize", roomSize);
      bodyFormData1.append("hub", hub);
      bodyFormData1.append("zone", zone);
      bodyFormData1.append("haveBanquateLawan", haveBanquateLawan ? "1" : "0");
      bodyFormData1.append("havelawn", havelawn ? "1" : "0");
      bodyFormData1.append("haveRestaurent", haveRestaurent ? "1" : "0");
      bodyFormData1.append("haveBar", haveBar ? "1" : "0");
      bodyFormData1.append("haveRoofTop", haveRoofTop ? "1" : "0");
      bodyFormData1.append("haveConferenceRoom", haveConferenceRoom ? "1" : "0");
      bodyFormData1.append("place_id", place_id);
      bodyFormData1.append("allowHourly", allowHourly ? "1" : "0");
      bodyFormData1.append("payAtHotel", travellerData.includes(TRAVELLER_CHOICE_TEXT.PayAtHotel) ? 1 : 0);
      if (editMode) {
        bodyFormData1.append("reSubmitted", 1);
        bodyFormData1.append("approved", 0)
      }

      // console.log("travellerData.includes(TRAVELLER_CHOICE_TEXT.PayAtHotel) - ", travellerData.includes(TRAVELLER_CHOICE_TEXT.PayAtHotel));
      // for (let [key, value] of bodyFormData1.entries()) {
      //   console.log(key, value);
      // }

      for (let i = 0; i < amenities.length; i++) { bodyFormData1.append(`amenities[${i}]`, amenities[i]); }
      try {
        let res = {};
        if (editMode) {
          res = await services.property.updateRRoomPropertyService({
            id: selectedData?.id,
            body: bodyFormData1,
          });
          setStep(1);
          createPropertyActionLogs('Property Detail Modified', selectedData?.id)
        } else {
          res = await services.property.createRRoomPropertyService(bodyFormData1);
          setSelectedData(res.data.data);
          createPropertyActionLogs('Property Created', res.data.data.id)
        }
        if (res.status === true || res.status === 200) {
          if (!editMode) {
            setStep(2);
            toast.success("Property Details Successfully Created !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
          } else {
            setShow(false);
            toast.success("Property Details Successfully Updated !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
          }
        }
        setPolicyText([]);
        getPropertyData();
        setPartial(false);
        setCouple(false);
        setLocal(false);
      } catch (error) {
        if (error.response.status === 409) {
          toast.error("Property Email or Mobile no. already Exist*", { autoClose: 2000, pauseOnHover: true, position: "top-right" });
        }
      }
    } else if (step === 2) {
      let bodyFormData2 = new FormData();
      if (imageData1.length) {
        imageData1.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "Facade");
        });
      }
      if (imageData2.length) {
        imageData2.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "Lobby");
        });
      }
      if (imageData3.length) {
        imageData3.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "DReception");
        });
      }
      if (imageData4.length) {
        imageData4.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "Room");
        });
      }
      if (imageData5.length) {
        imageData5.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "Washroom");
        });
      }
      if (imageData6.length) {
        imageData6.map((dataImg) => {
          bodyFormData2.append("images", dataImg);
          bodyFormData2.append("imageTitle", "Others");
        });
      }
      if (profileImg) {
        changeHeroImg();
      }
      try {
        let res = await services.property.updateRRoomPropertyService({
          id: selectedData?.id,
          body: bodyFormData2
        });
        if (res.status === true || res.status === 200) {
          resetImages();
          getPropertyData();
          if (!editMode) {
            toast.success("Property Images Successfully Created !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            setStep(3);
          } else {
            toast.success("Property Images Successfully Updated !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            setShow(false);
            setStep(1);
          }
        }
      } catch (error) { console.log("Error in onSubmit function") }
    }
  };

  const changeHeroImg = async () => {
    try {
      const res = await services.property.updatePropertyProfile(
        selectedData?.id,
        { profileImageID: profileImg }
      );

      if (res.status === 200) {
        onHide();
      }
    } catch (error) { console.log("Error in changeHeroImg function") }
  };

  useEffect(() => { setTravellerHandler(7); }, [Couple]);

  const setTravellerHandler = (item) => {
    if (travellerData.includes(item)) {
      setTravellerData(() => travellerData.filter((i) => i !== item));
    } else {
      setTravellerData([...travellerData, item]);
    }
  };

  const [showPopupForSoldOut, setShowPopupForSoldOut] = useState(false);

  const [soldOutForm, setSoldOutForm] = useState({
    selectReason: '',
    reason: ''
  })

  const [saveStatus, setSaveStatus] = useState({})

  const changeStatus = async (e, data) => {
    let val = e.target.value
    if (window.confirm("Are You Sure Want to change Status")) {
      if (val == 2) {
        setShowPopupForSoldOut(true);
        setSaveStatus(
          { status: val, data: data })
      }
      else {
        try {
          const bodyData = {
            status: val,
            id: data?.id,
          };
          const res = await services.property.changePropertyStatus(bodyData)
          if (res.data.status == true) {
            toast.success("Property Status Changed !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            createPropertyActionLogs('Changed Property Status', data.id)
            getPropertyData();
          }
        } catch (error) { console.log("Error in changeStatus function") }
      }

    }
  };

  const changeStatusFromPopup = async () => {
    if (soldOutForm.selectReason == "" || soldOutForm.reason == "") {
      toast.error("Please select Reason", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
    }
    else {
      try {
        const bodyData = {
          status: saveStatus?.status,
          id: saveStatus?.data?.id,
          reasonForSoldOut: soldOutForm?.selectReason + ", " + soldOutForm?.reason
        };
        const res = await services.property.changePropertyStatus(bodyData)
        if (res.data.status == true) {
          toast.success("Property Status Changed !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
          createPropertyActionLogs('Changed Property Status', saveStatus?.data?.id)
          getPropertyData();
          setShowPopupForSoldOut(false)
        }
      }
      catch (err) {
        console.log(err)
      }
    }
  }

  // const setPolicyHandler = (checkbox) => {
  //   if (checkbox.checked) {
  //     setPolicyText([...policyText, checkbox.value]);
  //   } else {
  //     setPolicyText((preVal) => preVal.filter((i) => i != checkbox.value));
  //   }
  // };

  const setPolicyHandler = (checkbox) => {
    const value = checkbox.value;
    const val = parseInt(value);
    setPolicyText((prev) => {
      let updated = [...prev];
      if (val === 0 || val === 1) {
        updated = updated.filter((v) => v !== "0" && v !== "1");
        if (checkbox.checked) updated.push(value);
      }
      else if (val === 2 || val === 3) {
        updated = updated.filter((v) => v !== "2" && v !== "3");
        if (checkbox.checked) updated.push(value);
      }
      else {
        if (checkbox.checked) {
          if (!updated.includes(value)) updated.push(value);
        } else {
          updated = updated.filter((v) => v !== value);
        }
      }
      return updated;
    });
  };

  const imageHandler1 = (data) => {
    setImageData1((preValue) => {
      return [...preValue, data];
    });
  };
  const imageHandler2 = (data) => {
    setImageData2((preValue) => {
      return [...preValue, data];
    });
  };
  const imageHandler3 = (data) => {
    setImageData3((preValue) => {
      return [...preValue, data];
    });
  };
  const imageHandler4 = (data) => {
    setImageData4((preValue) => {
      return [...preValue, data];
    });
  };
  const imageHandler5 = (data) => {
    setImageData5((preValue) => {
      return [...preValue, data];
    });
  };
  const imageHandler6 = (data) => {
    setImageData6((preValue) => {
      return [...preValue, data];
    });
  };

  const deleteHandler = async () => {
    try {
      const res = await services.property.deleteRRoomPropertyService(
        selectedData.id
      );

      if (res.status === 200) {
        dispatch(getRroomPropertyAction());
        getPropertyData();
        setShowDelete(false);
        toast.success("SuccesFully Deleted Property!", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    } catch (error) { }
  };

  const editHandler = async (item, step) => {
    try {
      const { data: { data }, } = await services.property.getPropertyCategoryServiceId(item.id);
      setEditDropDown(-1);
      setSelectedData(data);
      setStep(step);

      let editStateId = zones?.find((item) => {
        return item.name == data.zone
      })
      setSelectedZoneId(editStateId.id)

      let policy = data.bookingPolicy;

      if (data.bookingPolicy && isJsonString(data.bookingPolicy)) {
        const json = JSON.parse(data.bookingPolicy);
        policy = json.pop();
        setPolicyText(json);
      }

      if (data.partialPayment) setPartial(true);
      if (data.coupleFriendly) setCouple(true);
      if (data.locaidAccept) setLocal(true);

      setShow(true);
      setEditMode(true);

      setValue("propertyName", data.name);
      setValue("gstNumber", data.gstNumber);
      setValue("tanNumber", data.tanNumber);
      setValue("propertyDescription", data.propertyDescription);
      setValue("longitude", data.longitude);
      setValue("noOfRooms", data?.noOfRooms);
      setValue("latitude", data.latitude);
      setValue("propertyAddress", data.address);
      setValue("Locality", data.locality);
      setValue("state", data.stateId);

      setValue("city", data.city?.[0].id);
      setValue("postalCode", data.pincode);
      setValue("firstName", data.ownerFirstName);
      setValue("lastName", data.ownerLastName);
      setValue("panNumber", data.ownerPan);
      setValue("adharNumber", data.ownerAdhar);
      setValue("email", data.ownerEmail);
      setValue("phoneNumber", data.ownerMobile);
      setValue("firmType", data.propertyCategoryId);
      setValue("propertyEmail", data.propertyEmailId);
      setValue("propertyPhone", data.propertyMobileNumber);
      setValue("propertyLandmark", data.landmark);
      setValue("bookingPolicy", policy);
      setValue("PropertyPanNumber", data.PropertyPanNumber);

      setValue("onboardedRooms", data.onboardedRooms);
      setValue("roomsCommission", data.roomsCommission);
      // setValue("roomSize", data.roomSize);
      setValue("zone", data.zone || data.zone.id);
      setValue("hub", data.hub.id);
      setValue("haveBanquateLawan", data.haveBanquateLawan);
      setValue("haveRestaurent", data.haveRestaurent);
      setValue("haveBar", data.haveBar);
      setValue("haveRoofTop", data.haveRoofTop);
      setValue("haveConferenceRoom", data.haveConferenceRoom);
      setValue("allowHourly", data.allowHourly);
      setValue("place_id", data.place_id);


      setValue("firmTypeEntity", data.firmType);
      setValue(
        "amenities",
        arrayColumn(data.PropertyAmenities, "propertyAmenitiesId")
      );
      setselectedAminites(
        arrayColumn(data.PropertyAmenities, "propertyAmenitiesId")
      );
      let imagData1 = [];
      let imagData2 = [];
      let imagData3 = [];
      let imagData4 = [];
      let imagData5 = [];
      let imagData6 = [];
      data?.PropertyImage.map((data) => {
        let obj = {
          id: data.id,
          filename: data.image,
          filetype: "",
          fileimage: `${baseImgUrl}/${data.image}`,
          datetime: "",
          filesize: "",
          title: data?.title,
        };


        if (obj?.title === "Facade" || obj?.title?.charAt(0) === "F") {
          imagData1.push(obj);
        } else if (obj?.title === "Lobby" || obj?.title?.charAt(0) === "L") {
          imagData2.push(obj);
        } else if (
          obj?.title === "DReception" ||
          obj?.title?.charAt(0) === "D" ||
          obj?.title === "Reception"
        ) {
          imagData3.push(obj);
        } else if (obj?.title === "Room" || obj?.title?.charAt(0) === "R") {
          imagData4.push(obj);
        } else if (obj?.title === "Washroom" || obj?.title?.charAt(0) === "W") {
          imagData5.push(obj);
        } else {
          imagData6.push(obj);
        }
      });

      setImageSet1(imagData1);
      setImageSet2(imagData2);
      setImageSet3(imagData3);
      setImageSet4(imagData4);
      setImageSet5(imagData5);
      setImageSet6(imagData6);
    } catch (error) { }
  };

  const changeHandler = (e, data) => {
    if (e.target.checked) {
      setselectedAminites([...selectedAminites, Number(e.target.value)]);
    } else {
      const resultfilter = selectedAminites.filter((d, index) => {
        return d !== Number(e.target.value);
      });
      setselectedAminites(resultfilter);
    }
  };

  const deleteImageHandler = async (id) => {
    try {
      const res = await services.property.deletePropertyImageService(id);
      if (res.status === 200) {
        dispatch(getRroomPropertyAction());
        toast.success("Image Successfully Deleted !", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        setImageSet1(() => imageSet1.filter((i) => i.id !== id));
        setImageSet2(() => imageSet2.filter((i) => i.id !== id));
        setImageSet3(() => imageSet3.filter((i) => i.id !== id));
        setImageSet4(() => imageSet4.filter((i) => i.id !== id));
        setImageSet5(() => imageSet5.filter((i) => i.id !== id));
        setImageSet6(() => imageSet6.filter((i) => i.id !== id));
      }
    } catch (error) { }
  };

  // const propertyDataObj = useMemo(() => {
  //   return propertyList?.reduce(
  //     (acc, propertyList) => {
  //       const { approved, status } = propertyList || {};
  //       if (approved === PROPERTY_STATUS.APPROVED) {
  //         acc[PROPERTY_STATUS.APPROVED].push(propertyList);
  //       } else if (approved === PROPERTY_STATUS.REJECTED) {
  //         acc[PROPERTY_STATUS.REJECTED].push(propertyList);
  //       } else if (approved === PROPERTY_STATUS.PENDING) {
  //         acc[PROPERTY_STATUS.PENDING].push(propertyList);
  //       }
  //       if (status === 0) {
  //         acc[PROPERTY_STATUS.INACTIVE].push(propertyList);
  //       } else if (status === 1 && approved === PROPERTY_STATUS.APPROVED) {
  //         acc[PROPERTY_STATUS.ACTIVE].push(propertyList);
  //       }
  //       return acc;
  //     },
  //     {
  //       [PROPERTY_STATUS.ACTIVE]: [],
  //       [PROPERTY_STATUS.INACTIVE]: [],
  //       [PROPERTY_STATUS.APPROVED]: [],
  //       [PROPERTY_STATUS.REJECTED]: [],
  //       [PROPERTY_STATUS.PENDING]: [],
  //       [PROPERTY_STATUS.ALL]: propertyList,
  //     }
  //   );
  // }, [propertyList]);

  const propertyDataObj = useMemo(() => {
    return propertyList?.reduce(
      (acc, propertyList) => {
        const { approved, status, allowHourly, payAtHotel } = propertyList || {};
        if (approved === PROPERTY_STATUS.APPROVED) {
          acc[PROPERTY_STATUS.APPROVED].push(propertyList);
        } else if (approved === PROPERTY_STATUS.REJECTED && status == 0) {
          acc[PROPERTY_STATUS.REJECTED].push(propertyList);
        } else if (
          approved === PROPERTY_STATUS.PENDING
          // && status === PROPERTY_STATUS.PENDING
        ) {
          acc[PROPERTY_STATUS.PENDING].push(propertyList);
        }
        if (status == 0 && approved == 1) {
          acc[PROPERTY_STATUS.PENDINGSTATE].push(propertyList);
        }
        if (allowHourly == 1) {
          acc[PROPERTY_STATUS.HOURLY].push(propertyList);
        }
        if (payAtHotel == 0) {
          acc[PROPERTY_STATUS.PREPAID].push(propertyList);
        }
        // if (status === 0 && approved === 1) {
        if (status === 2) {
          acc[PROPERTY_STATUS.INACTIVE].push(propertyList);
        } else if (status === 1 && approved === 1) {
          acc[PROPERTY_STATUS.ACTIVE].push(propertyList);
        }
        return acc;
      },
      {
        [PROPERTY_STATUS.ACTIVE]: [],
        [PROPERTY_STATUS.INACTIVE]: [],
        [PROPERTY_STATUS.APPROVED]: [],
        [PROPERTY_STATUS.REJECTED]: [],
        [PROPERTY_STATUS.PENDING]: [],
        [PROPERTY_STATUS.PENDINGSTATE]: [],
        [PROPERTY_STATUS.HOURLY]: [],
        [PROPERTY_STATUS.PREPAID]: [],
        [PROPERTY_STATUS.ALL]: propertyList,
      }
    );
  }, [propertyList]);

  const propertyStatusTabs = useMemo(
    () => [
      {
        key: PROPERTY_STATUS.PENDING,
        title: `Requested (${propertyDataObj[PROPERTY_STATUS.PENDING]?.length})`,
      },
      {
        key: PROPERTY_STATUS.APPROVED,
        title: `Approved (${propertyDataObj[PROPERTY_STATUS.APPROVED]?.length})`,
      },
      {
        key: PROPERTY_STATUS.REJECTED,
        title: `Rejected (${propertyDataObj[PROPERTY_STATUS.REJECTED]?.length})`,
      },
      {
        key: PROPERTY_STATUS.ACTIVE,
        title: `Live (${propertyDataObj[PROPERTY_STATUS.ACTIVE]?.length})`,
      },
      {
        key: PROPERTY_STATUS.INACTIVE,
        title: `Sold-Out (${propertyDataObj[PROPERTY_STATUS.INACTIVE]?.length})`,
      },
      {
        key: PROPERTY_STATUS.PENDINGSTATE,
        title: `Pending (${propertyDataObj[PROPERTY_STATUS.PENDINGSTATE]?.length})`,
      },
      {
        key: PROPERTY_STATUS.HOURLY,
        title: `Hourly (${propertyDataObj[PROPERTY_STATUS.HOURLY]?.length})`,
      },
      {
        key: PROPERTY_STATUS.PREPAID,
        title: `Prepaid (${propertyDataObj[PROPERTY_STATUS.PREPAID]?.length})`,
      },
      {
        key: PROPERTY_STATUS.ALL,
        title: `All (${propertyList?.length})`,
      },
    ],
    [propertyDataObj]
  );


  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Users table",
    sheet: "Users",
  });

  const reApprove = async (approveSelect) => {
    const check = window.confirm("Are you Sure Want to Re-Approve this Property*");
    if (!check) { return; }
    try {
      const bodyData = {
        approved: 1,
        id: approveSelect,
      };
      const res = await services.property.changePropertyStatus(bodyData)
      if (res.status === 200) {
        toast.success("Property Approved SuccessFull !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        getPropertyData();
      }
    } catch (error) { console.log("Error in reApprove function") }
  };

  const [filterVal, setFilterVal] = useState({
    zone: 0,
    state: 0,
    hub: 0,
    city: 0
  })

  const getLocality = async (id) => {
    try {
      const locality = await Services.globalService.getLocalityByCity(id);
      if (locality.status === 200) {
        setLocalityData(locality.data.data);
      }
    } catch (error) { console.log("Error in getLocality function") }
  };

  const { city, state, zone, hub, propertyPhone, phoneOtp, propertyEmail, phoneNumber, email } = watch();

  useEffect(() => { if (city && show) { getLocality(city); } }, [city]);

  const searchfilter = (query) => {
    let text = query?.toLowerCase();
    const results = propertyDataObj[activeTab].filter((item) => {
      if (text == "") return propertyDataObj[activeTab];
      return (
        // item?.stateId?.toLowerCase()?.includes(text) ||
        item?.city?.name?.toLowerCase()?.includes(text) ||
        item?.name?.toLowerCase()?.includes(text) ||
        item?.propertyCode?.toLowerCase()?.includes(text) ||
        item?.noOfRooms?.toString()?.includes(text)
      );
    });
    setShowData(results);
  };

  useEffect(() => { setShowData(propertyDataObj[activeTab]); }, [activeTab, propertyList]);

  const fetchZones = async () => {
    try {
      const res = await services.property.allZoneService()
      if (res.data.status === true) { setZones(res.data.data) }
    }
    catch { console.log("Error in fetchZones function") }
  }

  useEffect(() => { fetchZones() }, [])

  const fetchStateByZones = async () => {
    try {
      const res = await services.property.getStateByZone(selectedZoneId)
      if (res.data.status === true) {
        setStates(res.data.data)
      }
    }
    catch { console.log("Error in fetchStateByZones function") }
  }

  useEffect(() => { if (zone) { fetchStateByZones() } }, [zone, selectedZoneId])

  const fetchHubByState = async () => {
    try {
      const res = await services.property.getHubByState(state)
      if (res.data.status === true) { setHubs(res.data.data.Hubs) }
    }
    catch { console.log("Error in fetchHubByState function") }
  }

  useEffect(() => { if (state) { fetchHubByState(state) } }, [state])

  const fetchCityByHub = async () => {
    try {
      const res = await services.property.getCityByHub(hub)
      if (res.data.status === true) { setCities(res.data.data) }
    }
    catch { console.log("Error in fetchCityByHub function") }
  }

  useEffect(() => { if (state) { fetchCityByHub(hub) } }, [hub])

  const tabLabels = {
    0: 'Updated By',
    1: 'Updated By',
    2: 'Rejected By',
    3: 'Approved By',
    4: 'Updated By'
  };

  const createPropertyActionLogs = async (action, id) => {
    try {
      const payload = {
        propertyId: id, action: action, actionBy: userDetail.id, data: {
          id: userDetail.id,
          name: userDetail.firstName
        }
      }
      const res = await services.property.propertyActionLogsService(payload)
    }
    catch (err) {
      console.log(err)
    }
  }

  const description = watch("propertyDescription") || "";
  const wordCount = description.trim().length > 0
    ? description.trim().split(/\s+/).length
    : 0;

  const exportPropertiesDataByTab = async () => {
    let arroved =
      activeTab == 0 ? 0 :
        activeTab == 1 ? 1 :
          activeTab == 2 ? 2 :
            activeTab == 3 ? 1 :
              activeTab == 4 ? 1 :
                activeTab == -1 ? '' : 0;

    let status =
      activeTab == 0 ? 0 :
        activeTab == 1 ? '' :
          activeTab == 2 ? 0 :
            activeTab == 3 ? 1 :
              activeTab == 4 ? 0 :
                activeTab == -1 ? '' :
                  0;
    try {
      const response = await services.property.getExportProperties(arroved, status, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("❌ Download failed:", err);
    }
  };

  // Auto fill
  const [ownerData, setOwnerData] = useState(null);
  const [showLoadButton, setShowLoadButton] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [showVerify, setShowVerify] = useState(null)

  useEffect(() => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isPhoneValid = /^[0-9]{10}$/.test(phoneNumber);
    const checkOwner = async () => {
      if ((isEmailValid || isPhoneValid) && !apiCalled) {
        const payload = {
          ownerMobile: phoneNumber,
          ownerEmail: email
        };
        try {
          let res = await services.property.checkOwnerExistService(payload);
          if (res.data.status === false) {
            setValue("firstName", '');
            setValue("lastName", '');
            setValue("panNumber", '');
            setValue("adharNumber", '');
            if (!phoneNumber) setValue("phoneNumber", '');
            setShowLoadButton(false);
            setOwnerData(null);
            setShowVerify(true)
          }
          if (res.data.status === true) {
            let owner = res.data.data
            setValue("firstName", owner.firstName);
            setValue("lastName", owner.lastName);
            setValue("panNumber", owner.ownerPan);
            setValue("adharNumber", owner.ownerAdhar);
            setValue("phoneNumber", owner.mobile);
            if (!editMode) {
              setValue("email", owner.email);
            }
            setShowLoadButton(true);
            setShowVerify(false)
          }
          setApiCalled(true);
        } catch (error) {
          console.error("API error:", error);
        }
      }
    };
    checkOwner();
  }, [phoneNumber, email]);

  useEffect(() => { setApiCalled(false) }, [phoneNumber, email]);

  const removeExsitOwner = () => {
    setValue("firstName", '');
    setValue("lastName", '');
    setValue("panNumber", '');
    setValue("adharNumber", '');
    setValue("phoneNumber", '');
    setValue("email", '');
    setShowLoadButton(false)
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    setFilterVal((prev) => ({ ...prev, [name]: value }))
  }

  return (
    <Layout
      title="RRooms Properties"
      buttonTitle="Create Property"
      openHandler={() => setShow(true)}
      searchfilter={searchfilter}
      searchType="search"
    >
      <div className="onboardDetails">
        <div className="wrap">
          <div className="inner">
            <div className="mb-2" style={{ borderBottom: 'solid 1px #000' }}>
              <div className="row justify-content-between">
                <div className="col-lg-10">
                  <Tabs
                    className="tabs"
                    activeKey={activeTab}
                    defaultActiveKey={PROPERTY_STATUS.UPCOMING}
                    onSelect={(tabKey) => setActiveTab(tabKey)}
                  >
                    {propertyStatusTabs.map((tab, ind) => { return <Tab eventKey={tab.key} key={ind} title={tab.title} />; })}
                  </Tabs>
                </div>
                <div className="col-lg-2 order-m-1">
                  <div className="flex row-sm align-items-center justify-content-end">
                    <div className="col-lg-6">
                      {
                        (userDetail.logintype === "rroomUser" && userDetail.role !== 10) && <button
                          onClick={exportPropertiesDataByTab}
                          className="btn-primary btn-sm fw-normal btn-block  mr-2"
                        >
                          Export Table
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="scrollTable">
              <table className="front-table" ref={tableRef}>
                <thead>
                  <tr>
                    <th>Zone</th>
                    <th>State</th>
                    <th>Hub</th>
                    <th>City</th>
                    <th>Locality</th>
                    <th>Property Code</th>
                    <th style={{ minWidth: 150 }}>Property Name</th>
                    <th>Property Category</th>
                    <th>Owner Name</th>
                    <th>Owner Mobile</th>
                    <th>Owner Email</th>
                    <th>Property Mobile</th>
                    <th>Property Email</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>TRC</th>
                    <th>SRC</th>
                    <th>Take Rate %</th>
                    <th>Agreement</th>
                    <th>Rrooms Status</th>
                    <th>Property Status</th>
                    <th>Initiator</th>
                    {
                      activeTab != -1 && <th>{tabLabels[activeTab]}</th>
                    }
                    {
                      activeTab == 1 && <th>Approved By</th>
                    }

                    <th>Rejection Reason</th>
                    <th>Special Comments</th>
                    <th style={{ minWidth: 250 }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {propertyDataObj[activeTab]?.length > 0 ? (
                    showData?.filter((item) => {
                      if (userDetail.logintype == 'rroomUser' && userDetail.role === 10) {
                        return item.createdBy === 10
                      }
                      return true
                    }).map((data, key) => (
                      <tr key={key}>
                        <td data-label="Zone">{data?.zone}</td>
                        <td data-label="State">{data?.state?.name}</td>
                        <td data-label="Hub">{data?.Hub?.hubname ? data?.Hub?.hubname : '-'}</td>
                        <td data-label="City">{data?.city.name ? data?.city.name : ''}</td>
                        <td data-label="Locality">{data.locality}</td>
                        <td data-label="Property Code">{data.propertyCode ?? "N/A"}</td>
                        <td data-label="Property Name" style={{ maxWidth: '360px', width: '360px', whiteSpace: 'nowrap' }}>
                          <Link to={`/property-details/${data.id}`} state={data} className="fs-8">
                            {
                              data?.name} {' '}
                            {data?.approved == 0 && (data?.propertyTransferred == 1 && <span className="badge bg-info" style={{ fontWeight: "500" }}>Owner Transfer</span> ||
                              data?.reSubmitted == 0 && data?.propertyTransferred == 0 && <span className="badge bg-success">New</span> || data?.reSubmitted == 1 && <span className="badge bg-warning text-dark fw-400">Modified</span>)
                            }
                          </Link>
                        </td>
                        <td data-label="Property Category">
                          {
                            data?.PropertyCategory?.name ? data?.PropertyCategory?.name : "N/A"
                          }
                        </td>
                        <td data-label="Owner Name">{data?.ownerFirstName ? data?.ownerFirstName + ' ' + data?.ownerLastName : '-'}</td>
                        <td data-label="Owner Mobile">{data?.ownerMobile ? data?.ownerMobile : '-'}</td>
                        <td data-label="Owner Email">{data?.ownerEmail ? data?.ownerEmail : '-'}</td>
                        <td data-label="Property Mobile">{data?.propertyMobileNumber ? data?.propertyMobileNumber : '-'}</td>
                        <td data-label="Property Email">{data?.propertyEmailId ? data?.propertyEmailId : '-'}</td>
                        <td data-label="Start Date">
                          {(() => {
                            const date = new Date(data.createdAt);
                            return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                          })()}
                        </td>
                        <td data-label="End Date">
                          {
                            data.onboarded_date ? <Moment format="DD-MM-YYYY">{data.onboarded_date}</Moment> : '-'
                          }

                        </td>
                        <td data-label="TRC">{data?.noOfRooms}</td>
                        <td data-label="SRC">{data?.onboardedRooms}</td>
                        <td data-label="Take Rate %">{data?.roomsCommission}</td>
                        <td
                          data-label="Agreement"
                          className={`text-center
                            ${data.agreement
                              ? "text-success"
                              : "text-danger"
                            }
                          `}
                        >
                          {data.agreement
                            ? "Accepted"
                            : "Pending"}
                        </td>
                        <td data-label="Rrooms Status" title={data?.approved == 2 && data?.remarkForCancellation}
                          className={
                            data.approved == 1
                              ? "text-success"
                              : data.approved == 2
                                ? "text-danger"
                                : "text-warning"
                          }
                        >
                          {data.approved == 1
                            ? "Approved"
                            : data.approved == 2
                              ? "Rejected"
                              : "Pending"}
                        </td>
                        <td data-label="Property Status">

                          <select
                            className={
                              `sm-select-box ${(activeTab == 0 || activeTab == -1) ? 'select-to-text' : ''} ${data.status == 0 && "text-danger sm-select-box" || data.status == 1 && "text-success" || data.status == 2 && "text-dark"}`
                            }
                            onChange={(e) => changeStatus(e, data)}
                            disabled={activeTab == 0 || activeTab == -1}
                            value={data.status}>
                            <option value="0">Pending</option>
                            <option value="1">Live</option>
                            <option value="2">Sold-Out</option>
                            <option value="3">Block</option>
                          </select>


                        </td>

                        <td data-label="Initiator">
                          {data?.creator?.firstName ? data?.creator?.firstName : '-'}
                        </td>
                        {
                          (activeTab == 0 || activeTab == 1 || activeTab == 4) &&
                          <td data-label="Updated By">
                            {data?.updater?.firstName ? data?.updater?.firstName : '-'}
                          </td>
                        }
                        {
                          activeTab == 1 &&
                          <td data-label="Approved By">
                            {data?.approver ? data?.approver?.firstName : '-'}
                          </td>
                        }

                        {
                          activeTab == 2 &&
                          <td data-label="Rejected By">
                            {data?.approver ? data?.approver?.firstName : '-'}
                          </td>
                        }

                        {
                          activeTab == 3 &&
                          <td data-label="Approved By">
                            {data?.approver ? data?.approver?.firstName : '-'}
                          </td>
                        }

                        <td data-label="Rejection Reason">{data?.remarkForCancellation ? data?.remarkForCancellation : '-'}</td>
                        <td data-label="Special Comments">{data?.remarks ? data?.remarks : '-'}</td>

                        <td data-label="ACTION">
                          <div className="button-group">
                            <Button
                              variant="primary"
                              className="btn-sm mr-2"
                              onClick={(e) => {
                                if (window.innerHeight <= e.clientY + 190) {
                                  setTopValueForEditList(e.clientY - 200);
                                } else {
                                  setTopValueForEditList(e.clientY);
                                }
                                setEditDropDown(
                                  key === editDropDown ? -1 : key
                                );
                              }}
                            >
                              <i
                                style={{ pointerEvents: "none" }}
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Button>
                            {/* {data.approved == 2 && (
                              <Button
                                variant="primary"
                                className="btn-sm mr-2"
                                onClick={() => reApprove(data?.id)}
                              >
                                Re-Approval
                              </Button>
                            )} */}

                            {/* {data.approved != 2 ? (
                              <>
                                <Button
                                  variant="primary"
                                  className="btn-sm mr-2"
                                  onClick={() => {
                                    setShowDelete(true);
                                    setSelectedData(data);
                                  }}
                                >
                                  <i
                                    className="fa fa-trash-o"
                                    aria-hidden="true"
                                  ></i>
                                </Button>

                              </>
                            ) : null} */}
                            {editDropDown === key && (
                              <>
                                <div
                                  className="editDrop"
                                  style={{
                                    top: `${topValueForEditList + 15}px`,
                                  }}
                                >
                                  <button
                                    className="btn p-0 m-0 position-absolute end-0 p-2 top-0"
                                    onClick={() => setEditDropDown(-1)}
                                  >
                                    <FontAwesomeIcon
                                      icon="fa-solid fa-circle-xmark"
                                      size="xl"
                                    />
                                  </button>
                                  <Button
                                    className="btn-sm mt-3"
                                    onClick={() => editHandler(data, 1)}
                                  >
                                    Edit Property Details
                                  </Button>
                                  <hr />
                                  <Button
                                    className="btn-sm"
                                    onClick={() => editHandler(data, 2)}
                                  >
                                    Edit Images
                                  </Button>
                                  <hr />
                                  <Button
                                    className="btn-sm"
                                    onClick={() => editHandler(data, 3)}
                                  >
                                    Edit Legal Entity
                                  </Button>
                                </div>
                                <div
                                  className="position-fixed bg-dark w-100 vh-100 top-0 start-0 "
                                  style={{ zIndex: 9999, opacity: 0.4 }}
                                ></div>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={16}>
                        <div
                          className="flex flex-column align-center justify-content-center full-width"
                          style={{ height: "10rem" }}
                        >
                          <FontAwesomeIcon
                            className="mb-2"
                            icon="fa-solid fa-ban"
                            style={{ width: "40px", height: "40px" }}
                            beat
                          />
                          <span>No Data</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showPopupForSoldOut}
        onHide={() => {
          setShowPopupForSoldOut(false);
        }}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sold-out Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-group">
            <label className="field-label">Select Reason</label>
            <select
              className="field-control"
              value={soldOutForm.selectReason}
              onChange={(e) => {
                setSoldOutForm({
                  ...soldOutForm,
                  selectReason: e.target.value
                })
              }}>
              <option>Select</option>
              <option>RROOMS Property</option>
              <option>Other Issue</option>
            </select>
          </div>
          <div className="form-group">
            <label className="field-label">Reason</label>
            <input
              type="text"
              className="field-control"
              value={soldOutForm.soldOutForm}
              onChange={(e) => {
                setSoldOutForm({
                  ...soldOutForm,
                  reason: e.target.value
                })
              }}
              placeholder="Enter Reason" />
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-primary btn-block" onClick={changeStatusFromPopup}>Submit</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="deleteModal">
              <span>Are you sure? Do you want to delete this record?</span>
              <span>You will not be able to recover this record!</span>
            </div>
            <Button
              variant="primary"
              className="btn-sm"
              type="button"
              onClick={deleteHandler}
            >
              Yes , Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        show={show}
        onHide={onHide}
        size="xl"
        className="modal_add_property"
        onShow={() => {
          editMode ? setStep(step) : setStep(1);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode ? "Edit Property" : "Property Onboarding"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!editMode && (
            <Row
              xs={12}
              className="gap-5 margin-sm-property align-items-center justify-content-center flex"
            >
              <div className="flex gap-1 align-items-center justify-content-center w-25">
                <span>Step:</span>
                <div
                  className={`stepOnboard ${step === 1 ? "" : "bg-secondary"}`}
                >
                  {(step === 2 || step === 3) && (
                    <FontAwesomeIcon
                      icon="fa-solid fa-check stepicon"
                      size="xl"
                      color="#000"
                    />
                  )}
                  <p>1</p>
                </div>
              </div>
              <div className="flex gap-1 align-items-center justify-content-center w-25">
                <span>Step:</span>
                <div
                  className={`stepOnboard ${step === 2 ? "" : "bg-secondary"}`}
                >
                  {step === 3 && (
                    <FontAwesomeIcon
                      icon="fa-solid fa-check stepicon"
                      size="xl"
                      color="#000"
                    />
                  )}
                  <p>2</p>
                </div>
              </div>
              <div className="flex gap-1 align-items-center justify-content-center w-25">
                <span>Step:</span>
                <div
                  className={`stepOnboard ${step === 3 ? "" : "bg-secondary"}`}
                >
                  <p>3</p>
                </div>
              </div>
            </Row>
          )}
          <Form
            className="popup-form onboardForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Container>
              {step === 1 && (
                <Row>
                  <Col xs={12} className="form-group">
                    <h6>Property Detail</h6>
                  </Col>

                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="propertyName"
                      text="Property Name *"
                      type="text"
                      placeholder="Enter property name"
                      field={"propertyName"}
                      register={register}
                      errors={errors}
                      autoFocus={true}
                    />
                    {errors?.propertyName?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"propertyName"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <label>Category</label>
                    <Controller
                      control={control}
                      name={"firmType"}
                      render={({ field: { onChange, value } }) => (
                        <select value={value} onChange={onChange}>
                          <option selected value={""} disabled>
                            Select
                          </option>
                          {categoryData.map((innerData, key) => (
                            <option key={key} value={innerData.id}>
                              {innerData.name}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors?.firmType?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"firmType"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="noOfRooms"
                      text="Total Rooms"
                      type="number"
                      placeholder="Total Rooms"
                      field={"noOfRooms"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.noOfRooms?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"noOfRooms"} />
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="onboardedRooms"
                      text="Signed Rooms"
                      type="number"
                      placeholder="Signed Rooms"
                      field={"onboardedRooms"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.onboardedRooms?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"onboardedRooms"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="roomsCommission"
                      text="Take Rate (%)"
                      type="number"
                      placeholder="Take Rate (%)"
                      field={"roomsCommission"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.roomsCommission?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"roomsCommission"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  {/* <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="roomSize"
                      text="Room Size"
                      type="text"
                      placeholder="Room Size"
                      field={"roomSize"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.roomSize?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"roomSize"} />
                        </span>
                      </div>
                    )}
                  </Col> */}

                  <Col xs={12} className="form-group">
                    <label>Property Description</label>
                    <textarea
                      {...register("propertyDescription", {
                        validate: (value) => {
                          const words = value?.trim()?.split(/\s+/).length;
                          return words <= 1000 || "Maximum 1000 words allowed";
                        }
                      })}
                      placeholder="Enter property description"
                      className="your-textarea-class"
                    />
                    <div className="text-muted fs-8 lh-1">*Max 1000 Words Allowed</div>
                    {errors?.propertyDescription?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"propertyDescription"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="latitude"
                      text="Latitude"
                      type="text"
                      placeholder="Enter Latitude"
                      field={"latitude"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.latitude?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"latitude"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="longitude"
                      text="Longitude"
                      type="text"
                      placeholder="Enter Longitude"
                      field={"longitude"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.longitude?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"longitude"} />
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="place_id"
                      text="Place Id"
                      type="text"
                      placeholder="Enter Place Id"
                      field={"place_id"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.place_id?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"place_id"} />
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col xs={4} className="form-group">
                    {/* <InputField
                      htmlFor="propertyEmail"
                      text="Property Email"
                      type="text"
                      placeholder="Enter Property Email"
                      field={"propertyEmail"}
                      register={register}
                      errors={errors}
                    /> */}
                    <VerifiedInput
                      label="Property Email"
                      placeholder="Enter Property Email"
                      fieldName="propertyEmail"
                      isEmail={true}
                      register={register}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      notValid={true}
                      verifyService={services.property.verifyEmailIdService}
                      editMode={editMode}
                    />
                    {errors?.propertyEmail?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"propertyEmail"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <VerifiedInput
                      label="Property Phone"
                      placeholder="Enter Property Phone"
                      fieldName="propertyPhone"
                      isEmail={false}
                      register={register}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      notValid={true}
                      verifyService={services.property.verifyPhoneNumberService}
                      editMode={editMode}
                    />
                    {errors?.propertyPhone?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"propertyPhone"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="propertyLandmark"
                      text="Property Landmark"
                      type="text"
                      placeholder="Enter Property Landmark"
                      field={"propertyLandmark"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.propertyLandmark?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"propertyLandmark"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>

                  {/* <Col xs={12} className="form-group" style={{ marginTop: '-0px' }}>
                    <Row>
                      {
                        isShowMobileOtp && <Col className="bg-light" xs={4}>
                          <label>Phone OTP</label>
                          <input
                            type="text"
                            id="phoneOtp"
                            placeholder="Enter Mobile OTP"
                            maxLength={4}
                            {...register("phoneOtp", {
                              onChange: handleMatchPhoneOtp,
                            })}
                            className="form-control"
                          />
                          {
                            showVerifiedTag != null && <p className="text-danger mb-0" style={{ fontSize: '10px' }}>Enter Valid OTP</p>
                          }
                        </Col>
                      }
                      {
                        isShowMobileOtp && <Col className="bg-light" xs={4}>
                          <label>Email OTP</label>
                          <input
                            type="text"
                            placeholder="Enter Mobile OTP"
                            maxLength={4}
                            {...register("phoneOtp", {
                              onChange: handleMatchEmailOtp,
                            })}
                            className="form-control"
                          />
                          {
                            showVerifiedTag != null && <p className="text-danger mb-0" style={{ fontSize: '10px' }}>Enter Valid OTP</p>
                          }
                        </Col>
                      }
                    </Row>
                  </Col> */}

                  <Col xs={4} className="form-group">
                    <label>Zone</label>
                    <Controller
                      control={control}
                      name="zone"
                      render={({ field: { onChange, value } }) => (
                        <select
                          value={value}
                          onChange={(e) => {
                            const selectedName = e.target.value;
                            onChange(selectedName); // for react-hook-form
                            const selectedZone = zones.find((z) => z.name === selectedName);
                            setSelectedZoneId(selectedZone?.id || "");
                          }}
                        >
                          <option value="">
                            Select Zone
                          </option>
                          {zones?.map((data) => (
                            <option key={data.id} value={data.name}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </Col>

                  <Col xs={4} className="form-group">
                    <label>State</label>
                    <Controller
                      control={control}
                      name={"state"}
                      render={({ field: { onChange, value } }) => (
                        <select onChange={onChange} value={value}>
                          <option selected disabled>
                            Select State
                          </option>
                          {states?.map((data, key) => (
                            <option key={key} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                  </Col>

                  <Col xs={4} className="form-group">
                    <label>Hub</label>
                    <Controller
                      control={control}
                      name={"hub"}
                      render={({ field: { onChange, value } }) => (
                        <select onChange={onChange} value={value}>
                          <option selected disabled>
                            Select Hub
                          </option>
                          {hubs?.map((data, key) => (
                            <option key={key} value={data.id}>
                              {data?.hubname}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors?.hub?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"hub"} />
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col xs={4} className="form-group">
                    <label>City</label>
                    <Controller
                      control={control}
                      name={"city"}
                      render={({ field: { onChange, value } }) => (
                        <select onChange={onChange} value={value}>
                          <option selected disabled>
                            Select City
                          </option>
                          {cities.map((data, key) => (
                            <option key={key} value={data.id}>
                              {data.name}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors?.city?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"city"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <label>Locality</label>
                    <Controller
                      control={control}
                      name={"Locality"}
                      render={({ field: { onChange, value } }) => (
                        <select value={value} onChange={onChange}>
                          <option selected value={""} disabled>
                            Select
                          </option>
                          {localityData.map((innerData, key) => (
                            <option key={key} value={innerData.name}>
                              {innerData.name}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors?.Locality?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"Locality"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={4} className="form-group">
                    <InputField
                      htmlFor="postalCode"
                      text="Postal Code"
                      type="text"
                      placeholder="Enter Postal Code"
                      field={"postalCode"}
                      register={register}
                      errors={errors}
                      max={6}
                    />
                    {errors?.postalCode?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"postalCode"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} className="form-group">
                    <label>Property Address *</label>
                    <textarea
                      register={register}
                      {...register("propertyAddress")}
                    ></textarea>
                    {errors?.propertyAddress?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"propertyAddress"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>


                  <Col xs={12}>
                    <div className="form-group full">
                      <label>Point of sale</label>
                      <div className="dis-flex">
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("haveBanquateLawan")} />Banquet
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("havelawn")} />Lawn
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("haveRestaurent")} />Restaurant
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("haveBar")} />Bar
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("haveRoofTop")} />Roof Top
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("haveConferenceRoom")} />Conference Room
                        </label>
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("allowHourly")} />Allow Hourly
                        </label>
                      </div>
                    </div>
                  </Col>

                  {/* <Col xs={12}>
                    <div className="form-group full">
                      <div className="dis-flex">
                        <label className="dis-flex checkbox-label">
                          <input type="checkbox" {...register("allowHourly")} />Allow Hourly
                        </label>
                      </div>
                    </div>
                  </Col> */}


                  <Col xs={12}>
                    <div className="form-group full">
                      <label>Property Amenities</label>
                      <ul className="flex">
                        {amenitiesData.filter((data) => data.type == "hotel").map((c, i) => (
                          <li key={i} className="amns">
                            <input
                              id={`amn${i}`}
                              type="checkbox"
                              value={c.id}
                              checked={selectedAminites.includes(c.id)}
                              {...register("amenities", {
                                onChange: (e) => changeHandler(e, c),
                              })}
                            />

                            <label
                              htmlFor={`amn${i}`}
                              className={
                                selectedAminites.includes(c.id)
                                  ? `activeLable`
                                  : ""
                              }
                            >
                              {c.name}
                            </label>
                          </li>
                        ))}
                      </ul>
                      {errors?.amenities?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>Please Select Amenities*</span>
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col xs={12} className="form-group">
                    <label htmlFor="bookingPolicy">Hotel Policy</label>
                    <textarea
                      register={register}
                      {...register("bookingPolicy")}
                      placeholder={"Enter Hotel Policy"}
                      style={{ height: "auto" }}
                      readOnly
                    ></textarea>

                    {errors?.bookingPolicy?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage
                            errors={errors}
                            name={"bookingPolicy"}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                  {propertyPolicy.map((item, index) => (
                    <Col
                      xs={12}
                      className="flex-nowrap align-items-start mb-1"
                      key={index}
                    >
                      <input
                        onChange={(e) => setPolicyHandler(e.target)}
                        type="checkbox"
                        id={`policy${index}`}
                        value={index}
                        name={`policy${index}`}
                        className="mt-1"
                        checked={policyText.includes(index.toString())}
                      />
                      <label
                        className="ml-2 m-0 text-black"
                        htmlFor={`policy${index}`}
                      >
                        {item}
                      </label>
                    </Col>
                  ))}
                  <Col xs={12} className="mt-4 mb-1">
                    <h6 style={{ fontSize: '12px' }}>Owner Details
                      {showLoadButton && (
                        <span type="button" className="text-danger text-default mt-2 ml-5">
                          This owner is already registered. <span onClick={removeExsitOwner} style={{ textDecoration: 'underline' }}>Please select a different owner to proceed.</span>
                        </span>
                      )}
                    </h6>
                  </Col>
                  <Col xs={6} className="form-group">
                    <VerifiedInput
                      label="Contact No. *"
                      placeholder="Enter phone number"
                      fieldName="phoneNumber"
                      isEmail={false}
                      register={register}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      notValid={showVerify}
                      verifyService={services.property.verifyPhoneNumberService}
                      editMode={editMode}
                    />

                    {errors?.phoneNumber?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"phoneNumber"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={6} className="form-group">
                    <VerifiedInput
                      label="Email ID"
                      placeholder="Enter email address"
                      fieldName="email"
                      isEmail={true}
                      register={register}
                      errors={errors}
                      watch={watch}
                      setValue={setValue}
                      notValid={showVerify}
                      verifyService={services.property.verifyEmailIdService}
                      editMode={editMode}
                    />
                    {/* {errors?.email?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"email"} />
                        </span>
                      </div>
                    )} */}
                  </Col>

                  <Col xs={6} className="form-group">
                    <InputField
                      htmlFor="firstName"
                      text="First Name"
                      type="text"
                      placeholder="Enter first name"
                      field={"firstName"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.firstName?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"firstName"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={6} className="form-group">
                    <InputField
                      htmlFor="lastName"
                      text="Last Name"
                      type="text"
                      placeholder="Enter Last name"
                      field={"lastName"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.lastName?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"lastName"} />
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col xs={6} className="form-group">
                    <InputField
                      htmlFor="panNumber"
                      text="PAN No.*"
                      type="text"
                      placeholder="Enter PAN number"
                      field={"panNumber"}
                      register={register}
                      errors={errors}
                    />
                    {errors?.panNumber?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"panNumber"} />
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col xs={6} className="form-group">
                    <InputField
                      htmlFor="adharNumber"
                      text="Aadhar No. *"
                      type="text"
                      placeholder="Enter adhar number"
                      field={"adharNumber"}
                      register={register}
                      errors={errors}
                      max={12}
                    />
                    {errors?.adharNumber?.message && (
                      <div className="error-text">
                        <img alt="" src={AlertIcon} />
                        <span>
                          <ErrorMessage errors={errors} name={"adharNumber"} />
                        </span>
                      </div>
                    )}
                  </Col>



                  <Col xs={12}>
                    <div className="form-group full">
                      <label>Traveller Choice</label>
                      <ul className="flex">
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="Couple"
                            checked={Couple}
                            onChange={() => setCouple(!Couple)}
                          />
                          <label
                            className={`checkLable ${Couple ? "activeLable" : ""
                              }`}
                            htmlFor="Couple"
                          >
                            Couple Friendly
                          </label>
                        </li>

                        <li className="amns">
                          <input
                            type="checkbox"
                            id="Local"
                            checked={Local}
                            onChange={() => setLocal(!Local)}
                          />
                          <label
                            className={`checkLable ${Local ? "activeLable" : ""
                              }`}
                            htmlFor="Local"
                          >
                            Local ID proof Accept
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="Partial"
                            checked={Partial}
                            onChange={() => setPartial(!Partial)}
                          />
                          <label className={`checkLable ${Partial ? "activeLable" : ""}`} htmlFor="Partial">
                            Partial Payment Accept
                          </label>
                        </li>

                        <li className="amns">
                          <input
                            type="checkbox"
                            id="short"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.short
                            )}
                            onChange={() => setTravellerHandler(1)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.short
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="short"
                          >
                            Short-Stays
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="corporate"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.Corporate
                            )}
                            onChange={() => setTravellerHandler(2)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.Corporate
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="corporate"
                          >
                            Corporate Deal
                          </label>
                        </li>

                        <li className="amns">
                          <input
                            type="checkbox"
                            id="familyVacation"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.FamilyVacation
                            )}
                            onChange={() => setTravellerHandler(3)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.FamilyVacation
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="familyVacation"
                          >
                            Family Vacation
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="checkIn"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.GuaranteedCheckIn
                            )}
                            onChange={() => setTravellerHandler(4)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.GuaranteedCheckIn
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="checkIn"
                          >
                            Guaranteed Check-In
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="groupCheckIn"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.GroupCheckIn
                            )}
                            onChange={() => setTravellerHandler(5)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.GroupCheckIn
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="groupCheckIn"
                          >
                            Group Check-In
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="solo"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.SoloTraveler
                            )}
                            onChange={() => setTravellerHandler(6)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.SoloTraveler
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="solo"
                          >
                            Solo Traveler
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="pet"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.PetFriendly
                            )}
                            onChange={() => setTravellerHandler(15)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.PetFriendly
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="pet"
                          >
                            Pet Friendly
                          </label>
                        </li>
                        <li className="amns">
                          <input
                            type="checkbox"
                            id="pay_hotel"
                            checked={travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.PayAtHotel
                            )}
                            onChange={() => setTravellerHandler(16)}
                          />
                          <label
                            className={`checkLable ${travellerData.includes(
                              TRAVELLER_CHOICE_TEXT.PayAtHotel
                            )
                              ? "activeLable"
                              : ""
                              }`}
                            htmlFor="pay_hotel"
                          >
                            Pay at Hotel
                          </label>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              )}
              {step === 2 && (
                <Row>
                  {imageData1?.length ||
                    imageData1?.length ||
                    imageData1?.length ||
                    imageData1?.length ||
                    imageData1?.length ||
                    imageData1?.length ? null : (
                    <Col>
                      <button
                        type="button"
                        className={`btn ${activeImageState ? "btn-success" : "btn-danger"
                          }`}
                        style={{
                          padding: 3,
                          fontSize: ".85rem",
                          marginTop: -20,
                        }}
                        onClick={
                          activeImageState
                            ? changeHeroImg
                            : () => setActiveImageState(!activeImageState)
                        }
                      >
                        {activeImageState
                          ? "Save Profile Image"
                          : "Choose Profile Image"}
                      </button>
                    </Col>
                  )}
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Facade"
                      imageHandler={imageHandler1}
                      selectedImages={imageSet1}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file1"}
                    />
                    {imageData1?.length + imageSet1.length <= 0 ||
                      (imageData1?.length + imageSet1.length > 5 && (
                        <div className="error-text">
                          <img alt="Facade" src={AlertIcon} />
                          <span>Please Select Images min 1 & max 5*</span>
                        </div>
                      ))}
                  </Col>
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Lobby"
                      imageHandler={imageHandler2}
                      selectedImages={imageSet2}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file2"}
                    />
                    {imageData2?.length + imageSet2.length <= 0 ||
                      (imageData2?.length + imageSet2.length > 5 && (
                        <div className="error-text">
                          <img alt="Lobby" src={AlertIcon} />
                          <span>Please Select Images min 1 & max 5*</span>
                        </div>
                      ))}
                  </Col>
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Reception"
                      imageHandler={imageHandler3}
                      selectedImages={imageSet3}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file3"}
                    />
                    {imageData3?.length + imageSet3.length <= 0 ||
                      (imageData3?.length + imageSet3.length > 5 && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>Please Select Images min 1 & max 5*</span>
                        </div>
                      ))}
                  </Col>
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Room"
                      imageHandler={imageHandler4}
                      selectedImages={imageSet4}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file4"}
                    />
                    {imageData4?.length + imageSet4.length <= 0 ||
                      (imageData4?.length + imageSet4.length > 5 && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>Please Select Images min 1 & max 5*</span>
                        </div>
                      ))}
                  </Col>
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Washroom"
                      imageHandler={imageHandler5}
                      selectedImages={imageSet5}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file5"}
                    />
                    {imageData5?.length + imageSet5.length <= 0 ||
                      (imageData5?.length + imageSet5.length > 5 && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>Please Select Images min 1 & max 5*</span>
                        </div>
                      ))}
                  </Col>
                  <Col xs={12}>
                    <ImageUploadBox
                      activeImageState={activeImageState}
                      setProfileImg={setProfileImg}
                      profileImgId={profileImg}
                      heading="Others"
                      imageHandler={imageHandler6}
                      selectedImages={imageSet6}
                      deleteHandler={deleteImageHandler}
                      htmlFor={"file6"}
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col
                  xs={12}
                  className="form-group justify-content-between flex"
                >
                  {step === 1 && (
                    <Button
                      variant="primary"
                      type="submit"
                      className={step === 1 && "align-self-end"}
                    >
                      {editMode ? "Update" : "Next"}
                    </Button>
                  )}
                  {step === 2 && (
                    <Button
                      variant="primary"
                      type="button"
                      onClick={() => {
                        if (
                          imageData1.length + imageSet1.length <= 5 &&
                          imageData1.length + imageSet1.length > 0 &&
                          imageData2.length + imageSet2.length <= 5 &&
                          imageData2.length + imageSet2.length > 0 &&
                          imageData3.length + imageSet3.length <= 5 &&
                          imageData3.length + imageSet3.length > 0 &&
                          imageData4.length + imageSet4.length <= 5 &&
                          imageData4.length + imageSet4.length > 0 &&
                          imageData5.length + imageSet5.length <= 5 &&
                          imageData5.length + imageSet5.length > 0
                        )
                          onSubmit();
                        else
                          toast.error("Select Images In all Categories!", {
                            autoClose: 1000,
                            pauseOnHover: true,
                            position: "top-right",
                          });
                      }}
                    >
                      {editMode ? "Update" : "Next"}
                    </Button>
                  )}
                </Col>
              </Row>
            </Container>
          </Form>
          {step === 3 && (
            <Step3
              data={{
                step: step,
                setStep: setStep,
                setShow: setShow,
                resetData: getPropertyCategory,
                selectedData: selectedData,
                editMode: editMode,
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </Layout >
  );
};

export default Property;
